import type { NestedObject } from '@gemini/lux-ds-pms';
import type {
  ContactDetailsInfo,
  Patient,
  PatientDetailsInfo,
} from '@store/patientStore';

export const hasContactFieldValue = (value?: unknown) => {
  if (value === undefined || value === null) {
    return false;
  }

  return typeof value === 'string' ? value.trim() !== '' : true;
};

export const getPatientDetailsToImport = (
  patients: Array<Patient | undefined>,
): PatientDetailsInfo | undefined => {
  const availablePatients = patients.filter(Boolean);

  if (!availablePatients.length) {
    return undefined;
  }

  const firstPatientOrder = Math.min(
    ...availablePatients.map(patient => patient?.order ?? 99),
  );

  return (
    availablePatients.find(patient => patient?.order === firstPatientOrder) ||
    availablePatients[0]
  )?.patientDetails;
};

export const hasContactDetailsValues = (
  details?: Pick<
    ContactDetailsInfo | PatientDetailsInfo,
    'dateOfBirth' | 'email' | 'firstName' | 'lastName' | 'phone'
  >,
) =>
  [
    details?.firstName,
    details?.lastName,
    details?.dateOfBirth,
    details?.email,
    details?.phone?.number,
  ].some(hasContactFieldValue);

export const getShouldResetContactDetails = ({
  checkboxValue,
  hasPatientDetailsToImport,
}: {
  checkboxValue?: boolean;
  hasPatientDetailsToImport: boolean;
}) => checkboxValue ?? hasPatientDetailsToImport;

export const buildContactDetailsOnUnmount = ({
  currentContactsDetails,
  formData,
}: {
  currentContactsDetails: ContactDetailsInfo;
  formData?: NestedObject;
}): ContactDetailsInfo | undefined => {
  const contactsDetailsData = formData?.contactsDetails as
    | ContactDetailsInfo
    | undefined;

  if (!contactsDetailsData) {
    return undefined;
  }

  return {
    ...contactsDetailsData,
    customFieldsMarketing: currentContactsDetails.customFieldsMarketing,
    storeCustomFieldsMarketing:
      currentContactsDetails.storeCustomFieldsMarketing,
  };
};
